import React from 'react';

import { NAO_INFORMADO } from 'components/molecules/bidding_summary_constants';

export const mapStringsToBulletLi = (scope: string, items: string[]): React.ReactNode[] => {
  const seen = new Map<string, number>();
  return items.map((item) => {
    const next = (seen.get(item) ?? 0) + 1;
    seen.set(item, next);
    const key = next === 1 ? `${scope}::${item}` : `${scope}::${item}#${next}`;
    return <li key={key}>{item}</li>;
  });
};

export const renderBulletOrEmpty = (scope: string, items: string[] | undefined): React.ReactNode =>
  items?.length ? (
    <ul className="pl-4 mb-0">{mapStringsToBulletLi(scope, items)}</ul>
  ) : (
    <p className="mb-0 text-muted">{NAO_INFORMADO}</p>
  );
